import { graphql, useStaticQuery } from "gatsby"

const useStylesLinks = () => {
  const data = useStaticQuery(
    graphql`
      {
        allIndexYaml(filter: { label: { eq: "Styles" } }) {
          edges {
            node {
              id
              label
              icon
              description
              items {
                id
                label
                url
                slug
                color
                icon
                component
                publish
                description
              }
            }
          }
        }
      }
    `
  )

  return data.allIndexYaml.edges[0].node
}

export default useStylesLinks
